const projects = [
    {
      id: 1.3,
      title: "FreshFinderTV",
      description: "Cuts through streaming overload to help you find your next great watch.",
      longDescription: "Built in React, FreshFinderTV is a personal project designed to make show discovery fast and effortless. Instead of endlessly scrolling through multiple apps, users can quickly find highly-rated shows across all major streaming platforms in one place. Focused on a clean, opinionated UI that gets you to a decision without the noise.",
      image: "/images/project_full/freshfinder/freshfinder_home_grid.png",
      image_md: "/images/project_full/freshfinder/freshfinder_home_grid.png",
      images: [
        "/images/project_full/freshfinder/freshfinder_besttv.png",
        "/images/project_full/freshfinder/freshpopup-new.png",
        "/images/project_full/freshfinder/freshfinder_show_card.png",
        "/images/project_full/freshfinder/freshfinder_home.png",
      ],
      tags: ["React", "Tailwind CSS", "REST APIs"],
      link: "https://freshfindertv.com",
      color: "#0a2a1a",
      year: "2025",
      role: "Personal Project",
      details: "",
    },
    {
      id: 1.5,
      title: "Ruth Page Dance Company",
      description: "Supporting front-end development for one of Chicago's most historic dance organizations.",
      longDescription: "Started as a supporting developer on this Webflow-based site and have since taken over as the sole developer, now owning all front-end work, including custom JavaScript, animations, and CSS, to keep the experience polished and in line with the company's artistic identity.",
      image: "/images/sm/ruthpage_sm.png",
      image_md: "/images/md/ruth_page.png",
      images: [
        "/images/project_full/ruth-page/ruth1.png",
        "/images/project_full/ruth-page/rp_ydtp.png",
        "/images/project_full/ruth-page/rp_program.png",
      ],
      tags: ["Webflow", "JavaScript", "CSS"],
      link: "https://ruthpage.org/home",
      color: "#1a1a3a",
      year: "2024",
      role: "UI Development & Cleanup",
      details: "",
    },
    {
      id: 1,
      title: "MeTV",
      description: "Full redesign of one of the most recognized TV networks in the country.",
      longDescription: "Led the front-end rebuild of metv.com: a full redesign for one of the most recognized TV networks in the country. The result is a fast, responsive experience that reaches thousands of viewers every day.",
      image: "/images/project_full/metv/metv-home.png",
      image_md: "/images/project_full/metv/metv-home.png",
      images: [
        "/images/project_full/metv/metv-home.png",
        "/images/project_full/metv/metv-favorites.png",
        "/images/project_full/metv/metv-stories.png",
        "/images/project_full/metv/metv-header-new.png",
        "/images/project_full/metv/metv-story-block.png",
      ],
      tags: ["HTML", "JavaScript", "CSS", "PHP"],
      link: "https://metv.com",
      color: "#1a4a8a",
      accent: "#3b82f6",
      year: "2022",
      role: "Full Redesign",
      details: "",
    },
    /* {
      id: 1.2,
      title: "Catchy Comedy",
      description: "Full site build for Catchy Comedy, a TV network that launched in 2023.",
      longDescription: "Built the complete web presence for a brand-new TV network from the ground up. Focused on fast load times, engaging UI, and a smooth experience across all devices from day one.",
      image: "/images/md/catchy_comedy_home_thumbnail.webp",
      image_md: "/images/md/catchy_comedy_home_thumbnail.webp",
      tags: ["HTML", "JavaScript", "CSS", "PHP"],
      link: "https://catchycomedy.com",
      color: "#3a1a1a",
      year: "2023",
      role: "New Site Build",
      details: "",
    }, */
    {
      id: 2.5,
      title: "Orthopaedic Trauma Association",
      description: "Redesign and rebuild of a national orthopaedic surgery membership organization's web presence.",
      longDescription: "Collaborated with a small team of three developers on a full redesign and rebuild of the Orthopaedic Trauma Association's website. Built on Drupal, using custom content types and taxonomies to give editors a flexible, structured authoring experience. Focused on clean information architecture, accessibility, and a polished experience across all devices.",
      image: "/images/project_full/ota/ota-home.png",
      image_md: "/images/project_full/ota/ota-home.png",
      images: [
        "/images/project_full/ota/ota-home.png",
        "/images/project_full/ota/ota-cta.png",
        "/images/project_full/ota/ota-research.png",
        "/images/project_full/ota/ota_portfolio.jpg",
      ],
      tags: ["Drupal", "HTML", "JavaScript", "CSS"],
      link: "https://ota.org",
      color: "#0a1a2a",
      year: "2024",
      role: "UI Development",
      details: "",
    },
   /* {
      id: 4,
      title: "MeTV Toons",
      description: "A cartoon-focused sub-brand site under the MeTV network.",
      longDescription: "Built the MeTV Toons web presence with a playful, colorful design system. Fast-loading, responsive, and consistent with the MeTV brand family.",
      image: "/images/sm/toons_sm.png",
      image_md: "/images/md/toons.png",
      tags: ["HTML", "JavaScript", "CSS"],
      link: "https://metvtoons.com",
      color: "#0a2a1a",
      year: "2022",
      role: "Front End Engineer",
      details: "",
    },
    {
      id: 6,
      title: "Svengoolie",
      description: "Official site for the beloved Chicago horror host Svengoolie.",
      longDescription: "Developed the Svengoolie.com site with PHP backend integration, custom animations, and a design that captures the campy horror aesthetic of the brand.",
      image: "/images/sm/sven_sm.png",
      image_md: "/images/md/sven.png",
      tags: ["HTML", "JavaScript", "CSS", "PHP"],
      link: "https://svengoolie.com",
      color: "#1a0a0a",
      year: "2021",
      role: "Front End Engineer",
      details: "",
    }, */
    {
      id: 7,
      title: "CBS58",
      description: "Front-end development for Milwaukee's CBS affiliate news platform. Multi-time winner of WBA's Best Website Award.",
      longDescription: "Built the front-end for a high-traffic daily news platform. Speed, accessibility, and a clean reading experience were the priority so readers can get the latest stories fast.",
      images: [
         "/images/md/cbs58_home_thumbnail_v3.webp",
         "/images/cbs58/cbs58_2.webp",
         "/images/cbs58/cbs58_3.webp",
         "/images/cbs58/cbs58_5.webp",
      ],
      image_md: "/images/md/cbs58_home_thumbnail_v3.webp",
      tags: ["PHP", "JavaScript", "CSS", "HTML"],
      link: "https://cbs58.com",
      color: "#0a1a2a",
      year: "2025",
      role: "Full Redesign",
      details: "",
    },
    /* {
      id: 8.5,
      title: "Compeer",
      description: "Front-end development for Voice & Vision's Compeer program, connecting volunteers with adults in mental health recovery.",
      longDescription: "Built front-end pages and components for Compeer, a Voice & Vision, Inc. program pairing volunteers in one-to-one friendships with adults in mental health recovery. Work included the site's resources page, podcast page for the Untold Valor podcast, and general UI development across the WordPress site.",
      image: "/images/project_full/compeer/compeer-home-lg.png",
      image_md: "/images/project_full/compeer/compeer-home-lg.png",
      images: [
        "/images/project_full/compeer/compeer-home-callout.png",
        "/images/project_full/compeer/compeer-podcast.png",
        "/images/project_full/compeer/compeer-interior.png",
      ],
      tags: ["WordPress", "PHP", "HTML", "JavaScript", "CSS"],
      link: "https://compeerfriends.org",
      color: "#0a1a3a",
      year: "2026",
      role: "UI Development",
      details: "",
    }, */
    {
      id: 8,
      title: "Ensono",
      description: "Lead front-end developer on a full Drupal redesign for a global IT firm.",
      longDescription: "Served as lead front-end developer on a full redesign of Ensono's enterprise Drupal site. Built complex page templates and reusable components, working closely with design and backend teams throughout.",
      image: "/images/project_full/ensono/ensono_thumbnail.png",
      image_md: "/images/project_full/ensono/ensono_thumbnail.png",
      images: [
        "/images/project_full/ensono/ensono_home.png",
        "/images/project_full/ensono/ensono_hybrid-cloud.png",
        "/images/project_full/ensono/ensono_mainframe.png",
        "/images/project_full/ensono/ensono_managed-infrastructure.png",
      ],
      tags: ["Drupal", "Bootstrap", "HTML", "JavaScript", "CSS"],
      link: "https://ensono.com",
      color: "#0a0a2a",
      year: "2020",
      role: "Full Redesign",
      details: "",
    },
  ];
  
  export default projects;